"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFilterAnalyzedTools = exports.useGetAuditData = void 0;
var get_1 = __importDefault(require("lodash/fp/get"));
var react_redux_firebase_1 = require("react-redux-firebase");
var filter_1 = require("utils/filter");
var useGetAuditData = function (companyId) { return (0, react_redux_firebase_1.useFirestoreConnect)(function () { return [companyId && {
        collection: 'audits',
        where: [
            ['companyId', '==', companyId],
            ['isActive', '==', true],
            ['isPublished', '==', true],
        ],
        // orderBy: ['date', 'desc']
    }].filter(Boolean); }); };
exports.useGetAuditData = useGetAuditData;
var useFilterAnalyzedTools = function (serviceStatsList) { return (0, filter_1.useFilterItems)(serviceStatsList, [(0, get_1.default)('service.name'), (0, get_1.default)('service.niceName')], [filter_1.toolGroupCheck]); };
exports.useFilterAnalyzedTools = useFilterAnalyzedTools;
